import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Environment, EnvironmentService } from '@galaxy/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

interface ListLocationIDsResponse {
  data: string[];
}

export interface Group {
  name: string;
  pathNodes: string[];
  hasAccess: boolean;
}
interface ListChildGroupsResponse {
  data: Group[];
}

@Injectable({ providedIn: 'root' })
export class BrandsApiService {
  constructor(private http: HttpClient, private environmentService: EnvironmentService) {
    (<any>window).brandsAPI = this;
  }

  public listLocationIDs(groupPath: string): Observable<string[]> {
    const url = this.hostWithScheme() + '/api/v2/node-list-locations';
    const params = new HttpParams().set('groupPath', groupPath);
    return this.http.post<ListLocationIDsResponse>(url, params, this.apiOptions()).pipe(map((r) => r.data));
  }

  public listChildGroups(partnerId: string, groupPath: string): Observable<Group[]> {
    const url = this.hostWithScheme() + '/api/v2/node-list-child-groups';
    const params = new HttpParams()
      .set('groupPath', groupPath)
      .set('partnerId', partnerId)
      .set('includeDescendantsFlag', 'true');
    return this.http.post<ListChildGroupsResponse>(url, params, this.apiOptions()).pipe(map((r) => r.data));
  }

  private host(): string {
    switch (this.environmentService.getEnvironment()) {
      case Environment.LOCAL:
        return 'nbrg-test.appspot.com';
      case Environment.TEST:
        return 'nbrg-test.appspot.com';
      case Environment.DEMO:
        return 'nbrg-demo.appspot.com';
      case Environment.PROD:
        return 'nbrg-prod.appspot.com';
    }
  }

  private hostWithScheme(): string {
    const scheme = this.environmentService.getEnvironment() === Environment.LOCAL ? 'http://' : 'https://';
    return scheme + this.host();
  }

  private apiOptions(): { headers: HttpHeaders; withCredentials: boolean } {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
      }),
      withCredentials: true,
    };
  }
}
